import { TextField } from '@material-ui/core';
import { TextErr } from 'component/customize_style_component/styled_title';
import { Spinner } from 'react-bootstrap';
import { useStyles } from '../../containers/quiz_manager/fashion_restriction/styles';

const MultipleSelectOptions = ({
    slide,
    loadingQuestionData,
    handleMultiSelect,
    customValue,
    handleTextFieldChange,
    customValueError,
}) => {
    const classes = useStyles();

    const isOtherSelected = slide?.options?.find((item) => item.value === 'Other' && item.isSelect);

    return (
        <div className={`${classes.styleContainer} style-container`}>
            <div className={classes.styleContainer}>
                {/* <div className={classes.heading}>{slide?.subTitle?.replace('? ', '?\n')}</div> */}
                {slide?.options?.length && !loadingQuestionData ? (
                    <div className={classes.optionContainer}>
                        {slide?.options?.map((option, index) => (
                            <div
                                key={index}
                                className={classes.option}
                                style={{
                                    background: option.isSelect ? '#F2D4BD' : '#ffffff',
                                    border: option.isSelect && '1px solid #ffffff',
                                }}
                                onClick={() => handleMultiSelect(option)}
                            >
                                {option.title}
                            </div>
                        ))}
                        {isOtherSelected ? (
                            <div className={`mt-3 w-100 ${classes.customTextField}`}>
                                <TextField
                                    style={{
                                        width: '100%',
                                        fontSize: 16,
                                    }}
                                    value={customValue}
                                    multiline
                                    maxRows={4}
                                    required
                                    onChange={handleTextFieldChange}
                                />
                                {customValueError && (
                                    <TextErr style={{ display: 'block' }}>This field is required</TextErr>
                                )}
                            </div>
                        ) : null}
                    </div>
                ) : loadingQuestionData ? (
                    <div className={`${classes.optionContainer} w-100`}>
                        <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default MultipleSelectOptions;
